import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import { DocumentViewer } from 'react-documents';
import FileViewerLogic from './FileViewer.logic';
import classes from './FileViewer.module.css';
import expand from 'assets/expand.svg';
import shrink from 'assets/shrink.svg';
import classNames from 'classnames';
import CustomLink from 'shared_ui_components/CustomLink';
import CustomViewer from 'shared_ui_components/CustomViewer/CustomViewer/CustomViewer';

const FileViewer = ({
  activeStep,
  handleMarkAsRead = () => null,
  improvements,
  downloadExcel,
  viewFile,
}) => {
  const {
    isFile,
    loading,
    link,
    isDisabled,
    documentLoaded,
    isExcel,
    isImage,
    onFilePreviewLoad,
    isWord,
    isPdf,
    isFFEnabled,
    isSimpleFile,
    isPresentation,
    includedFiles,
  } = FileViewerLogic({
    activeStep,
    handleMarkAsRead,
  });
  const [isExpanded, setIsExpanded] = useState(false);
  const onExpand = () => {
    if (!improvements) return;
    setIsExpanded((prev) => !prev);
  };

  useEffect(() => {
    return () => {
      setIsExpanded(false);
    };
  }, []);

  if (isImage)
    return (
      <div className={classes.imageWrapper}>
        <object
          onLoad={(e) => {
            handleMarkAsRead ? handleMarkAsRead(activeStep) : e.preventDefault();
          }}
          data={activeStep.content}
          type="image/svg+xml"
        >
          <img className={classes.img} src={activeStep.content} alt="Uploaded file" />
        </object>
      </div>
    );

  // Show preview only for document types
  // Show preview only for documents < 25mb
  if (!isFile || isDisabled)
    return (
      <CustomLink
        className={`primaryBtn ${classes.btn}`}
        linktext="Click to go"
        onClick={(e) => {
          viewFile(activeStep.content);
          handleMarkAsRead ? handleMarkAsRead(activeStep) : e.preventDefault();
        }}
      />
    );

  return (
    <div className={classNames(['fileViewer', isExpanded && classes.expandedContainer])}>
      {loading && (
        <div style={styleContainer}>
          <CircularProgress style={styleProgress} size={24} />
        </div>
      )}
      <div className={classNames([isExpanded && classes.expanded])}>
        {improvements ? (
          <div className={classNames([classes.container])}>
            {isFFEnabled && includedFiles ? (
              <CustomViewer
                url={link}
                onLoad={onFilePreviewLoad}
                isExcel={isExcel}
                isWord={isWord}
                isPdf={isPdf}
                isSimpleFile={isSimpleFile}
                isPresentation={isPresentation}
                documentLoaded={documentLoaded}
              />
            ) : (
              <>
                <div style={{ userSelect: "none" }}>
                <iframe
                  title="document"
                  src={`https://docs.google.com/gview?url=${link}&embedded=true`}
                  sandbox="allow-scripts allow-same-origin allow-pointer-lock" // Disables the popup button
                  style={{
                    height: documentLoaded ? (isExpanded ? '90vh' : '65vh') : 0,
                    width: '100%',
                    'margin-bottom': '25px',
                    opacity: documentLoaded ? 1 : 0,
                  }}
                  onLoad={onFilePreviewLoad}
                  onContextMenu={(e) => e.preventDefault()}
                />
                  </div>
                {!loading && (
                  <button onClick={onExpand} className={classes.expandBtn}>
                    <img src={isExpanded ? shrink : expand} alt="Expand" />
                  </button>
                )}
              </>
            )}
          </div>
        ) : (
          <DocumentViewer
            queryParams="hl=en"
            url={link}
            viewer="google"
            loaded={onFilePreviewLoad}
            googleCheckContentLoaded
            googleMaxChecks={100}
            style={{
              height: documentLoaded ? '65vh' : 0,
              width: '100%',
              'margin-bottom': '25px',
              userSelect: 'none',
            }}
          />
        )}
      </div>
      {/* Quick fix as excel files are not being rendered by the google viewer */}
      {!loading && isExcel && downloadExcel && (
        <CustomLink
          className={`primaryBtn ${classes.btn}`}
          linktext="Download"
          onClick={(e) => {
            viewFile(activeStep.content);
            handleMarkAsRead ? handleMarkAsRead(activeStep) : e.preventDefault();
          }}
        />
      )}
    </div>
  );
};

export default FileViewer;

const styleProgress = {
  color: '#0494fd',
};

const styleContainer = {
  textAlign: 'center',
};
